import React from 'react'
import "./Page_Footer.css"
const Page_Footer = () => {
  return (
   

<div></div>


  )
}

export default Page_Footer
